module.exports = __webpack_public_path__ + "ca4e790269cba3e1b3c2a761b267293c.svg";